import React, { useState, useEffect } from "react";
import Modal from "../UI/Modal";
import Button from "../UI/Button";

const RunCronModal = ({
  isOpen,
  onClose,
  onRun,
  templates=[]
}) => {

  const [week,setWeek] = useState(1);
  const [subject,setSubject] = useState("");
  const [body,setBody] = useState("");

  const loadTemplate = (weekNumber) => {

    const t = templates.find(
      x => x.week_number === weekNumber
    );

    if(t){

      setSubject(t.subject || "");
      setBody(t.html_content || "");

    }

  };

  const handleWeekChange = (weekNumber) => {

    setWeek(weekNumber);

    loadTemplate(weekNumber);

  };

  const handleRun = () => {

    onRun({
      week,
      subject,
      html_content:body
    });

  };

  useEffect(()=>{

  if(isOpen){
    loadTemplate(1);
  }

},[isOpen]);

  return (

    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Run Cron Task"
      footer={
        <>
          <Button
            variant="secondary"
            onClick={onClose}
          >
            Cancel
          </Button>

          <Button
            onClick={handleRun}
          >
            Run Cron
          </Button>
        </>
      }
    >

      <div className="space-y-4">

        <div>

          <label className="text-sm font-medium">
            Week
          </label>

          <select
            value={week}
            onChange={(e)=>
              handleWeekChange(Number(e.target.value))
            }
            className="border rounded-lg w-full p-2 mt-1"
          >

            <option value={1}>Week 1</option>
            <option value={2}>Week 2</option>
            <option value={3}>Week 3</option>
            <option value={4}>Week 4</option>

          </select>

        </div>

        <div>

          <label className="text-sm font-medium">
            Subject
          </label>

          <input
            value={subject}
            onChange={(e)=>
              setSubject(e.target.value)
            }
            className="border rounded-lg w-full p-2 mt-1"
          />

        </div>

        <div>

          <label className="text-sm font-medium">
            Body
          </label>

          <textarea
            rows="10"
            value={body}
            onChange={(e)=>
              setBody(e.target.value)
            }
            className="border rounded-lg w-full p-2 mt-1"
          />

        </div>

      </div>

    </Modal>

  );

};

export default RunCronModal;